import {DceComponent, DceHTMLElement} from "dce-engine";
import Dce from "dce-engine/lib/decorators/Dce";

interface TabsProps {
    tabsContentSelector: string,
    buttonActiveClass: string
}

@Dce("Tabs")
export default class Tabs extends DceComponent<TabsProps> {

    constructor(elem: DceHTMLElement, props: TabsProps) {
        super(elem, props);

        this.elem.querySelectorAll('a').forEach(elem => {
            elem.addEventListener('click', evt => {
                this.switchTo(elem as HTMLElement);
            });
        });

        if(window.location.hash) {
            this.showTabContent(window.location.hash);
        }

    }

    private switchTo(button: HTMLElement) {

        let tabId = button.getAttribute('href');

        this.showTabContent(tabId);

    }

    private showTabContent(tabHash: string){

        let tabs = Array.from(document.querySelector(this.props.tabsContentSelector).children) as HTMLElement[];

        for (const tab of tabs) {
            if('#' + tab.id != tabHash){
                tab.style.display = 'none';
            }else{
                tab.style.display = null;
            }
        }

        this.elem.querySelectorAll('a').forEach(a => {
            if(a.classList.contains(this.props.buttonActiveClass)){
                a.classList.remove(this.props.buttonActiveClass);
            }

            console.log(a.href, tabHash);

            if(a.href.endsWith(tabHash)){
                console.log('set class')
                a.classList.add(this.props.buttonActiveClass)
            }
        });

    }

}